 
export const organize_format = (origin: string, array: { [key: string]: any }[]) => {

 //   console.log('array  :  ',array)

        for (let i = 0; i < array.length; i++ ){

            let lesson = array[i];

            if (typeof lesson === 'object') {
                    
                if ( !!lesson.lesson_id ) { lesson.uid = lesson.lesson_id;  }
                if ( !!lesson.extra_url ) { lesson.uid +=  lesson.extra_url;  }
                if ( !!lesson.app )       { lesson.name = lesson.app;  }
                if ( !lesson.lesson_id )  { lesson.lesson_id = "";  }
                if ( !lesson.liked )      { lesson.liked = 0;  }
                if ( !lesson.totalLikes ) { lesson.totalLikes = 0;  }
                if ( !lesson.selected )   { lesson.selected = 0;  }
                if ( !lesson.viewed )     { lesson.viewed = 0;  }
                if ( !lesson.approved )   { lesson.approved = 999;  }
            
                lesson.origin = origin;

                lesson.search = lesson.search || "";

                lesson.search += " ";

                lesson.search += lesson.name;

                lesson.search += " ";

                lesson.search += lesson.uid;

                if ( lesson.name_heb ) {
                  lesson.search += " ";
                  lesson.search += lesson.name_heb;
                }

                if ( lesson.author ) { lesson.search += lesson.author; }

                let grades = "";

                if ( lesson.grades && lesson.grades.length ) {
                    for (let j = 0; j < lesson.grades.length; j++) {
                        if (lesson.grades[j] !== '0') { 
                          grades += (j+1);
                        }
                        
                    }
                    lesson.grades = "";
                    lesson.classes = grades;
                }
            }

        }


       // console.log('array  :  ',array)
        return array

       
    }




















/* 

        function classes_as_letters(classes){

        var a = map(func,classes);

        return a.join(" ");

        function func(i){
        return "0אבגדהוז"[i]+"'"
        }
        }
 

 */
